// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"f459ddbc","484":"7e6519f4","551":"16589e52","828":"da73ed6f","842":"a45ab6d0","851":"29c5feda"}[chunkId] + ".chunk.js";
};